import { withCacheBust } from "../lib/avatarUtils";

const COLORS = [
  "bg-rose-500", "bg-orange-500", "bg-amber-500", "bg-emerald-500",
  "bg-teal-500", "bg-cyan-500", "bg-blue-500", "bg-indigo-500",
  "bg-violet-500", "bg-fuchsia-500", "bg-pink-500", "bg-sky-500",
];

function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return parts[0].slice(0, 2).toUpperCase();
}

function getColor(name) {
  let hash = 0;
  for (const ch of (name || "")) hash = ch.charCodeAt(0) + ((hash << 5) - hash);
  return COLORS[Math.abs(hash) % COLORS.length];
}

export default function UserAvatar({ user, size = "md", className = "" }) {
  const sizes = {
    sm: "w-10 h-10 text-sm",
    md: "w-24 h-24 text-3xl",
  };
  const sizeClass = sizes[size] || sizes.sm;

  if (user?.avatar_url) {
    return (
      <img
        src={withCacheBust(user.avatar_url, user.avatar_cache_bust)}
        alt={user.name}
        className={`${sizeClass.split(" ").slice(0, 2).join(" ")} rounded-full object-cover border border-primary/20 flex-shrink-0 ${className}`}
        data-testid="user-avatar-img"
      />
    );
  }

  const initials = getInitials(user?.name);
  const color = getColor(user?.name);

  return (
    <div
      className={`${sizeClass} ${color} rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 select-none ${className}`}
      data-testid="user-avatar-initials"
    >
      {initials}
    </div>
  );
}
